import http, { request } from './http';

export interface SmokeCleanupResult {
  projectId?: number;
  status?: string;
  name?: string;
  action?: string;
}

/** 清理冒烟测试项目（仅 test 账号，且项目名以 [冒烟测试] 开头） */
export async function cleanupSmokeTestProject(projectId: number): Promise<SmokeCleanupResult> {
  const res = await request<{ success?: boolean; message?: string; data?: SmokeCleanupResult }>(
    http.delete(`/smoke-test/projects/${projectId}`),
  );
  if (res && typeof res === 'object' && 'success' in res && res.success === false) {
    throw new Error(res.message || '清理项目失败');
  }
  return (res as { data?: SmokeCleanupResult })?.data ?? (res as SmokeCleanupResult) ?? {};
}

const FIXTURE_BASE = '/smoke-test-fixtures';

export async function fetchSmokeFixtureFile(fileName: string, mimeType: string): Promise<File> {
  const url = `${FIXTURE_BASE}/${encodeURIComponent(fileName)}`;
  const resp = await fetch(url, { credentials: 'same-origin' });
  if (!resp.ok) {
    throw new Error(`加载测试夹具失败: ${fileName} (HTTP ${resp.status})`);
  }
  const blob = await resp.blob();
  return new File([blob], fileName, { type: mimeType || blob.type || 'application/octet-stream' });
}
